import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Device } from '../../../models/device';
import { ActivatedRoute, Router } from '@angular/router';
import { DevicesService } from '../../../services/devices.service';
import { CardDataFormComponent } from '../card-data-form/card-data-form.component';
import { DeviceDataFormComponent } from '../device-data-form/device-data-form.component';
import { FuelParamsFormComponent } from '../fuel-params-form/fuel-params-form.component';
import { PhotoParamsFormComponent } from '../photo-params-form/photo-params-form.component';
import { DeviceScheduleFormComponent } from '../device-schedule-form/device-schedule-form.component';
import { LoaderComponent } from '../../../utils/loader/loader.component';
import { NipFormComponent } from '../nip-form/nip-form.component';
import { LoginUserModel } from '../../../models/loginUserModel';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SkeletonModule } from 'primeng/skeleton';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-device-form',
  imports: [
    LoaderComponent, CommonModule, FormsModule, ReactiveFormsModule,
    CardDataFormComponent, DeviceDataFormComponent, FuelParamsFormComponent,
    PhotoParamsFormComponent, DeviceScheduleFormComponent, NipFormComponent,
    TabViewModule, ButtonModule, DialogModule, SkeletonModule
  ],
  templateUrl: './device-form.component.html',
  styleUrl: './device-form.component.scss'
})
export class DeviceFormComponent {
  device!: Device | null;
  showHistoric = false;
  isSaving = false;
  historicData: any;
  data!: LoginUserModel;
  activeTab = '0';
  @ViewChild(FuelParamsFormComponent) fuelParamsForm!: FuelParamsFormComponent;

  get isAdmin() { return this.data.UserType === 'Administrator' || this.data.UserType === 'Modify'; }

  constructor(
    private route: ActivatedRoute,
    private service: DevicesService,
    private router: Router,
    private toastSrv: ToastService
  ) {
    this.data = JSON.parse(localStorage.getItem('data')!);
  }

  @Input() cardNumber!: number;

  ngOnInit() { this.loadDeviceInfo(this.cardNumber); }

  backButton() { this.router.navigate(['app/dispositivos']); }

  loadDeviceInfo(number: number) {
    this.service.loadInfoDevice(number, this.data.Client_number).subscribe({
      next: (resp: any) => { this.device = resp; },
      error: () => { this.device = null; }
    });
  }

  loadHistoric() {
    if (this.fuelParamsForm) {
      this.fuelParamsForm.showHistorial();
    }
  }

  showSavingModal(event: boolean) { this.isSaving = event; }

  showResponseModal(event: any) {
    if (event.isSave) {
      this.toastSrv.add({
        type: event.errorCode === 0 ? 'success' : 'error',
        message: event.errorDesc
      });
      this.loadDeviceInfo(this.cardNumber);
    } else {
      this.historicData = event.data;
      this.showHistoric = true;
    }
  }
}
